/**
 * ISO string → ms epoch in the given timezone. Thin wrapper around
 * `moment.tz` so the merger stays timezone-aware without each helper
 * repeating the import + tz-parse line. Exported so `mergePicks.ts`,
 * `isExactDuplicate.ts`, and the day reducers all use the same parser.
 */
import moment from 'moment-timezone';

export function toMs(iso: string, timezone: string): number {
  return moment.tz(iso, timezone).valueOf();
}
